module.exports = __webpack_public_path__ + "media/images/payments-cdeeea5f73a8e302f4b133e574b18cb6.png";